import parseTipRates from 'src/utils/parseTipRates'

// Backend ships tipping as a raw type string ('tipping' | 'cover_costs'
// | 'both' | 'no_tipping') alongside a separate tip_rates object; the
// rest of the widget consumes a single fused shape with the type
// collapsed into independent booleans. v6 does its fusion in its pack
// entry; v7 keeps it inside React so the pack stays a one-liner, and
// exposing booleans means consumers don't re-derive them.
//
// The tip_rates half is shared with v6 via utils/parseTipRates — only
// the two booleans below are v7-specific.
const parseTipping = (type, tipRates) => ({
  tippingEnabled: type == 'tipping' || type == 'both',
  coverCostsEnabled: type == 'cover_costs' || type == 'both',
  ...parseTipRates(tipRates),
})

export default parseTipping
